module.exports = __webpack_public_path__ + "static/media/progman_11.aa5b9df7.ico";